<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card card-form">
          <div class="card-header">
            <div class="row">
              <div class="col">
                <h4 class="card-title float-left">{{ $t('config.productCategory.title') }}</h4>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-lg-6 col-md-6">
                <div class="row">
                  <div class="col-9">
                    <div class="form-group">
                      <label>{{ $t('config.products.productCategory.title') }}<span class="red">*</span></label>
                      <v-select v-model="productModel.productCategory" label="name"
                                :options="categories"
                                :filterable="false"
                                @search="onCategorySearch"
                                @search:focus="onCategoryFocus">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="productModel.productCategory && productModel.productCategory && productModel.productCategory.text">
                          <div v-html="productModel.productCategory.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-3">
                    <label>Бренд Қўшиш</label>
                    <span class="input-group-button">
                    <button @click="addProductCategoryModal" class="btn btn-info">
                      <i class="fa fa-plus"></i> Add
                    </button>
                  </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-9">
                    <div class="form-group">
                      <label>{{ $t('config.products.productManufacture.title') }}<span class="red">*</span></label>
                      <v-select v-model="productModel.productManufacture" label="name"
                                :options="manufactures"
                                :filterable="false"
                                @search="onProductManufactureSearch"
                                @search:focus="onProductManufactureFocus">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="productModel.productManufacture && productModel.productManufacture && productModel.productManufacture.text">
                          <div v-html="productModel.productManufacture.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-3">
                    <label>Бренд Қўшиш</label>
                    <span class="input-group-button">
                    <button @click="addProductManufactureModal" class="btn btn-info">
                      <i class="fa fa-plus"></i> Add
                    </button>
                  </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>{{ $t('config.products.country') }}<span class="red">*</span></label>
                      <v-select v-model="productModel.country" label="name"
                                :options="countryList"
                                :filterable="false"
                                @search="onCountrySearch"
                                @search:focus="onCountryFocus"
                                :class="{invalid : $v.productModel.country.$error}">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="productModel && productModel.country && productModel.country.name">
                          <div v-html="productModel.country.name"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                      <div class="red" v-if="$v.productModel.country.$error">
                        {{ $t("auto.autoType.country") }} {{ $t("messages.combo.empty") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>{{ $t("fitment.fitmentType") }} <span class="red">*</span></label>
                      <v-select v-model="productModel.fitmentType" label="name"
                                :options="fitmentTypes"
                                :filterable="false"
                                @search="onFitmentTypesSearch"
                                @search:focus="onFitmentTypesFocus">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="productModel.fitmentType && productModel.fitmentType && productModel.fitmentType.text">
                          <div v-html="productModel.fitmentType.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <div class="form-check checkbox-inline">
                        <label class="form-check-label pl-0">
                          <input class="form-check-input" type="checkbox"
                                 v-model="productModel.status"
                                 name="status">
                          <span class="form-check-sign"></span>
                          {{ $t('config.products.status') }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-6 col-md-6">
                <div class="row">
                  <div class="col-9">
                    <div class="form-group">
                      <label>{{ $t('config.products.productSubCategory.title') }}<span class="red">*</span></label>
                      <v-select v-model="productModel.productSubCategory" label="name"
                                :options="subCategories"
                                :filterable="false"
                                @search="onSubCategorySearch"
                                @search:focus="onSubCategoryFocus">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="productModel.productSubCategory && productModel.productSubCategory && productModel.productSubCategory.text">
                          <div v-html="productModel.productSubCategory.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-3">
                    <label>Бренд Қўшиш</label>
                    <span class="input-group-button">
                    <button @click="addProductSubCategoryModal" class="btn btn-info">
                      <i class="fa fa-plus"></i> Add
                    </button>
                  </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>{{ $t('config.products.productModel.title') }}<span
                          class="red">*</span></label>
                      <input type="text" class="form-control" v-model="productModel.name"
                             :class="{invalid : $v.productModel.name.$error}"/>
                      <div class="red" v-if="$v.productModel.name.$error">
                        {{ $t("auto.autoType.model") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>{{ $t('config.products.measurement') }}<span class="red">*</span></label>
                      <v-select v-model="productModel.unitMeasurement" label="name"
                                :options="measurementTypeList"
                                :filterable="false"
                                @search="onMeasurementTypeSearch"
                                @search:focus="onMeasurementTypeFocus">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="productModel.unitMeasurement && productModel.unitMeasurement && productModel.unitMeasurement.text">
                          <div v-html="productModel.unitMeasurement.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>{{ $t('config.products.customs') }}<span
                          class="red">*</span></label>
                      <input type="number" class="form-control" v-model="productModel.customs"
                             :class="{invalid : $v.productModel.customs.$error}"/>
                      <div class="red" v-if="$v.productModel.customs.$error">
                        {{ $t("messages.combo.empty") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="row mt-5">
              <div class="col-12 btns-box">
                <button class="all-btn add-btn" @click="save"
                        :disabled="processing">
                  {{ $t("action.save") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ProductCategoryModal/>
    <ProductSubCategoryModal/>
    <ProductManufactureModal/>
  </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import initFilterModel from '@/shared/filter';
import ProductCategoryModal from '@/views/config/product-plus/ProductCategoryModal';
import ProductSubCategoryModal from '@/views/config/product-plus/ProductSubCategoryModal';
import ProductManufactureModal from '@/views/config/product-plus/ProductManufactureModal';
import {clone} from '@/shared/utils';

export default {
  name: "ProductModelAddEdit",
  components: {
    ProductCategoryModal,
    ProductSubCategoryModal,
    ProductManufactureModal
  },
  data() {
    return {
      processing: false,
      filter: initFilterModel(),
      categoryFilter: initFilterModel(),
      subCategoryFilter: initFilterModel(),
      productManufactureFilter: initFilterModel(),
      productModel: {
        status: true,
      },
      categories: [],
      subCategories: [],
      fitmentTypes: [],
      countryList: [],
      measurementTypeList: [],
      manufactures: []
    }
  },
  validations() {
    return {
      productModel: {
        productCategory: {
          required: required
        },
        name: {
          required: required
        },
        country: {
          required: required
        },
        unitMeasurement: {
          required: required
        },
        customs: {
          required: required
        },
        fitmentType: {
          required: required
        }
      }
    }
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;

      if (id && id > 0) {
        this.$http.get('/product-model/' + id).then(res => {
          vm.productModel = res.data;
          this.processing = false;
        }, () => {
          this.$swal({
            title: this.$t('messages.common.error'),
            text: this.$t('messages.common.errorOccurred'),
            type: 'error'
          });
          this.processing = false;
        })
      }
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.processing = true;
      this.$http.post('/product-model/save', this.productModel)
          .then(res => {
                const response = res.data;
                if (response.statusCode === 'OK') {
                  this.$router.push('/config/products');
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.productModel.name + '\n' + res.data.message,
                    type: 'warning'
                  });
                }
                this.processing = false;
              }
          ).catch(error => {
        this.$swal({
          title: this.$t('messages.common.error'),
          text: this.$t('messages.common.errorOccurred') + '\n' + error.response.data.message,
          type: 'error'
        });
        this.processing = false;
      });

    },

    onCategorySearch(searchTxt, loading) {
      loading(true);
      this.categoryFilter.search = searchTxt;
      this.searchMethodCategory(loading);
    },
    onCategoryFocus() {
      this.categoryFilter.search = '';
      this.searchMethodCategory();
    },
    searchMethodCategory(loading) {
      this.categories = [];
      this.subCategories = [];
      this.$http.post('product-category-plus/search', this.categoryFilter).then(res => {
        if (loading)
          loading(false);
        this.categories = res.data.data;
      }, err => {
        console.log(err);
      });
    },
    onSubCategorySearch(searchTxt, loading) {
      if (!this.productModel.productCategory) {
        return;
      }
      loading(true);
      this.subCategoryFilter.search = searchTxt;
      this.subCategoryFilter.parentId = this.productModel.productCategory.id;
      this.searchMethodSubCategory(loading);
    },

    onSubCategoryFocus() {
      if (!this.productModel.productCategory) {
        return;
      }
      this.subCategoryFilter.search = '';
      this.subCategoryFilter.parentId = this.productModel.productCategory.id;
      this.searchMethodSubCategory();
    },
    searchMethodSubCategory(loading) {
      this.productSubCategories = [];
      this.$http.post('product-sub-category-plus/search', this.subCategoryFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.subCategories = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onProductManufactureSearch(searchTxt, loading) {
      loading(true);
      if (!this.productModel.productCategory) {
        return;
      }
      if (!this.productModel.productCategory) {
        return;
      }
      this.productManufactureFilter.search = searchTxt;
      this.productManufactureFilter.productCategoryId = this.productModel.productCategory.id;
      this.productManufactureFilter.productSubCategoryId = this.productModel.productSubCategory.id;
      this.searchProductManufacture(loading);
    },

    onProductManufactureFocus() {
      this.productManufactureFilter.search = '';
      this.productManufactureFilter.productCategoryId = this.productModel.productCategory.id;
      this.productManufactureFilter.productSubCategoryId = this.productModel.productSubCategory.id;
      this.searchProductManufacture();
    },

    searchProductManufacture(loading) {
      this.manufactures = [];
      this.$http.post('product-manufacture/search', this.productManufactureFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.manufactures = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onCountrySearch(searchTxt) {
      this.countryList = [];
      this.filter.search = searchTxt;
      this.$http.post('country/search', this.filter)
          .then(res => {
            this.countryList = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onCountryFocus() {
      this.countryList = [];
      this.filter.search = '';
      this.$http.post('country/search', this.filter)
          .then(res => {
            this.countryList = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    getRentType() {
      this.$http.get('/fitment-types')
          .then(res => {
            this.fitmentTypes = res.data;
          }, err => {
            console.log(err);
          });
    },

    getData() {
      this.processing = true;

      this.$http.get('measurementTypes', this.filter)
          .then(res => {
            this.processing = false;
            this.measurementTypeList = res.data;
          }, err => {
            this.processing = false;
            console.log(err);
          });
    },
    onMeasurementTypeSearch(searchTxt) {
      this.processing = true;
      this.measurementTypeList = [];
      this.filter.search = searchTxt;
      this.getData();
    },
    onMeasurementTypeFocus() {
      this.processing = true;
      this.measurementTypeList = [];
      this.filter.search = null;
      this.getData();
    },

    getFitmentTypesData() {
      this.processing = true;

      this.$http.get('fitment-types', this.filter)
          .then(res => {
            this.processing = false;
            this.fitmentTypes = res.data;
          }, err => {
            this.processing = false;
            console.log(err);
          });
    },
    onFitmentTypesSearch(searchTxt) {
      this.processing = true;
      this.fitmentTypes = [];
      this.filter.search = searchTxt;
      this.getFitmentTypesData();
    },
    onFitmentTypesFocus() {
      this.processing = true;
      this.fitmentTypes = [];
      this.filter.search = null;
      this.getFitmentTypesData();
    },
    cancel() {
    },

    addProductCategoryModal() {
      this.$eventBus.$emit('showProductCategoryModal');
    },

    addProductSubCategoryModal() {
      this.$eventBus.$emit('showProductSubCategoryModal');
    },

    addProductManufactureModal() {
      this.$eventBus.$emit('showProductManufacturesModal');
    }


  },

  computed: {},

  created() {
    this.$eventBus.$on('AutoTypeValueByType', (data, type) => {
      if (data && type == 'Manufacture') {
        this.autoType.autoManufactureDto = clone(data);
      } else if (data && type == 'Category') {
        this.autoType.carCategoryDto = clone(data);
      }
    });
    this.init();
    this.getRentType();
  }
}
</script>

<style scoped>
.custom {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.custom td, .custom th {
  border: 1px solid #ddd;
  padding: 4px;
}

.custom tr:nth-child(even) {
  background-color: #f2f2f2;
}

.custom tr:hover {
  opacity: 1;
  background-color: #dee2e6;
}

.custom thead tr th {
  border-bottom-width: 1px;
  padding-top: 4px;
  padding-bottom: 4px;
  text-align: center !important;
  color: #9A9A9A;
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: 400;
}

.custom tr {
  font-size: 14px;
}

</style>